import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import moment from "moment";
import { Card } from "primereact/card";
import { trainingApi } from "../../services";
import { Button } from 'primereact/button';

const TrainingDetailsView = ({ clickedRowData }) => {
  const user = useSelector(selectUser);
  const [peerManagerView, setPeerManagerView] = useState(false);
  const [reqTrainingPurpose, setReqTrainingPurpose] = useState([]);
  const [outComeTrainingPurpose, setOutComeTrainingPurpose] = useState([]);
  // const [currentstatus, setCurrentstatus] = useState();

  useEffect(() => {
    // fetchRequestedTraining();
    // fetchEngagement();
    const empIndex = user.roles.indexOf('PM');
    setPeerManagerView(empIndex !== 1);
  }, []);

  // const fetchEngagement = () => {
  //   trainingApi.getEngagementTypes().then((resp) => {
  //     let proStatus = resp.data.data.find(item => item.id === clickedRowData?.status);
  //     setCurrentstatus(proStatus.title);
  //   });
  // };

  const fetchRequestedTraining = () => {
    trainingApi.getRequestedTraining().then((resp) => {
      const purposeReqTrainingData = resp?.data?.data?.filter(item => item.type === 0);
      const businessOutcomeTrainingData = resp?.data?.data?.filter(item => item.type === 1);

      const idsToMatchRequestedTraining = clickedRowData?.purposeOfRequestedTraining.split(',').map(id => parseInt(id, 10));
      const clickedRequestedTraining = purposeReqTrainingData.filter(item => idsToMatchRequestedTraining.includes(item.id)).map(item => item.title);
      setReqTrainingPurpose(clickedRequestedTraining);

      const idsToMatchOutComes = clickedRowData?.businessoutcome.split(',').map(id => parseInt(id, 10));
      const clickedOutComeTraining = businessOutcomeTrainingData.filter(item => idsToMatchOutComes.includes(item.id)).map(item => item.title);
      setOutComeTrainingPurpose(clickedOutComeTraining);
    });
  };

  return (
    <>
      <hr />
      <div className="row mp-panel">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Project Name :</div>
            <div className='col'>
              {clickedRowData?.projectName ? clickedRowData?.projectName : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Type :</div>
            <div className='col'>
              {clickedRowData?.trainingType ? clickedRowData?.trainingType : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Target Skill :</div>
            <div className='col'>
              {clickedRowData?.targetSkills ? clickedRowData?.targetSkills?.title : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Category Of Training :</div>
            <div className='col'>
              {clickedRowData?.categoryOfTrainings ? clickedRowData?.categoryOfTrainings?.title : '-'}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-3">
            <div className='col trf-Detail-Label'>Start Date for Training :</div>
            <div className='col'>
              {clickedRowData?.startDate ? moment(clickedRowData?.startDate).format("DD-MM-YYYY") : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>End Date for Training :</div>
            <div className='col'>
              {clickedRowData?.endDate ? moment(clickedRowData?.endDate).format("DD-MM-YYYY") : '-'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Training Status :</div>
            <div className='col'>
              {clickedRowData?.trainingDetailStatus === 0 ? 'Not Started' : clickedRowData?.trainingDetailStatus === 1 ? 'In Progress' : 'Completed'}
            </div>
          </div>

          <div className="col-3">
            <div className='col trf-Detail-Label'>Completed Course Duration :</div>
            <div className='col'>
              {clickedRowData?.assignedCourseHours ? clickedRowData?.assignedCourseHours : '00'}
              {":"}
              {clickedRowData?.assignedCourseMinutes ? clickedRowData?.assignedCourseMinutes : '00'}
            </div>
          </div>

          {/* <div className="col-3">
            <div className='col trf-Detail-Label'>View Certificate :</div>
            <div className='col'>
              <Button label="View" disabled />
            </div>
          </div> */}
        </div>
      </div>

      {clickedRowData?.businessoutcomeDetails.map((item, index) => (
        <div className="row mp-panel">
          <div className="grid">
            <div className="col-12">
              <div className='col trf-Detail-Label'>Which of business outcome (s) mentioned below going to be directly/indirectly impacted as an effectiveness of requested training ?</div>
              <div className='col mr-2 bordered mt-1'>
                {item.title}
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Current Skill Competency Level :</div>
            <div className='col'>
              {clickedRowData?.currentLevel ? clickedRowData?.currentLevel === 1 ? 'Beginner with no knowledge' : clickedRowData?.currentLevel === 2 ? 'Beginner with basic knowledge' : clickedRowData?.currentLevel === 3 ? 'Intermediate with good knowledge but no hands-on experience' : clickedRowData?.currentLevel === 4 ? 'Intermediate with strong hands-on experience' : clickedRowData?.currentLevel === 5 ? 'Expert' : '-' : '-'}
            </div>
          </div>

          <div className="col-6">
            <div className='col trf-Detail-Label'>Expected Skill Competency Level :</div>
            <div className='col'>
              {clickedRowData?.expectedLevel ? clickedRowData?.expectedLevel === 1 ? 'Beginner with no knowledge' : clickedRowData?.expectedLevel === 2 ? 'Beginner with basic knowledge' : clickedRowData?.expectedLevel === 3 ? 'Intermediate with good knowledge but no hands-on experience' : clickedRowData?.expectedLevel === 4 ? 'Intermediate with strong hands-on experience' : clickedRowData?.expectedLevel === 5 ? 'Expert' : '-' : '-'}
            </div>
          </div>
        </div>
      </div> */}

      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Progress Update :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>{clickedRowData?.progressUpdate ? clickedRowData?.progressUpdate : 'Not Updated Yet'}</Card>
            </div>
          </div>
          <div className="col-6">
            <div className='col trf-Detail-Label'>Training Learnings :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>{clickedRowData?.trainingLearning ? clickedRowData?.trainingLearning : 'Not Updated Yet'}</Card>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="grid">
          <div className="col-6">
            <div className='col trf-Detail-Label'>Learning Apply on Project :</div>
            <div className='col'>
              <Card style={{ background: "#F2F6F9" }}>{clickedRowData?.learningApplyOnProject ? clickedRowData?.learningApplyOnProject : 'Not Updated Yet'}</Card>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row mp-panel">
        <div className="grid">
          <div className="col-12">
            <div className='col trf-Detail-Label'>Purpose of Requested Training :</div>
            {clickedRowData?.purposeOfRequestedTraining.map((item, index) => (
              <div className='col mr-2 bordered mt-1'>
                {item.title}
              </div>
            ))}
          </div>
        </div>
      </div> */}


    </>
  )
}
export default TrainingDetailsView;
